(function () {
  "use strict";

  freeContentResource.$inject = ['$resource', 'errorHandler'];
  angular
    .module('trainerWebApp.resources')
    .factory('freeContentResource', freeContentResource);

  function freeContentResource($resource, errorHandler) {

    var data = null;

    var freeContentResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/free-content');

    freeContentResource.prototype.load = function load(resultCb, errorCb) {
      if (!data) {
        freeContentResource.get(function (res) {
          data = res;
          resultCb(data);
        }, errorHandler.defaultServerErrorHandler(errorCb));
      } else {
        resultCb(data);
      }
    };

    return new freeContentResource;
  }

})();
